import { render, staticRenderFns } from "./DoctorCertificationModal.vue?vue&type=template&id=c37e7136&"
import script from "./DoctorCertificationModal.vue?vue&type=script&lang=js&"
export * from "./DoctorCertificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports